<template>
  <div class="spaceCenter">
    <div class="exchange-card" v-loading="loading || isNetworkLoading">
      <div class="exchange-tab-box spaceCenter">
        <img src="@/assets/image/transfer/tansfer.png" style="width: 0.28rem; margin-right: 0.12rem" />
        TN Bridge
      </div>
      <div class="exchange-tab-body">
        <div style="position: relative">
          <div class="network-container from-container" :class="{ 'switch-down': isNetworkSwitching }">
            <div style="display: flex;align-items: center;margin-bottom: .11rem;">
              <div class="word-sm" style="line-height: 0 !important;">From：</div>
              <div class="unit-icon inline-block">
                <img v-if="fromType == 'Ethereum'" src="@/assets/image/transfer/eth.png" style="width: 0.2rem" />
                <img v-if="fromType == 'Treasurenet'" src="@/assets/image/exchange/unit.png" style="width: 0.2rem" />
                <div style="padding-left: .05rem;">
                  <div
                    style="font-family: HurmeGeometricSans2, HurmeGeometricSans2;font-weight: 600;font-size: .22rem;color: #fff;">
                    {{ fromType }}
                  </div>
                </div>
              </div>
              <!-- <component
                  :is="fromType == 'ETH' ? 'metaMaskComp' : 'keplrComp'"
                /> -->

              <span class="word-sm" style="width: 100%;text-align: right;font-weight: normal;
        font-family: PlusJakartaDisplay-Medium, PlusJakartaDisplay;color: #929DAD !important;">
                Balance :
                <template v-if="isBalanceLoading">
                  <i class="el-icon-loading"></i>
                </template>
                <template v-else>
                  <big-number :number.sync="balance" />
                </template>
              </span>

            </div>
            <div class="spaceBetween exchange-item"
              style="display: flex;padding-bottom: .2rem !important;padding-top: .32rem !important;flex-direction: column;width: 100%;">
              <div style="flex: 1;display: flex; flex-direction: column;align-items: flex-end;width: 100%;">
                <div style="display: flex; justify-content: space-between;align-items: center;width: 100% !important;">
                  <el-input class="exchange-input" style="height: 100%;" placeholder="0.00" v-model="exchangeNum"
                    @input="handleAmountInput" onkeyup="this.value=this.value.match(/\d+\.?\d{0,18}/);" />
                  <div class="spaceBetween" style="margin-bottom: 0.02rem;padding: 0 !important;">
                    <el-dropdown trigger="click" @command="handleFromTokenChange">
                      <div class="unit-icon inline-block">
                        <img :src="getTokenIcon(fromToken, fromType)" style="width: 0.22rem; margin-right: 0.1rem" />
                        <div
                          style="flex: 1;display: flex;justify-content: flex-end;-webkit-justify-content: flex-end;flex-direction: row;">
                          <div
                            style="font-family: PlusJakartaDisplay, PlusJakartaDisplay;font-size: .22rem;color: #DCE0E7;display: flex;align-items: center;">
                            {{ fromTokenText }}
                            <i class="el-icon-arrow-down"></i>
                          </div>
                        </div>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="token in getAvailableFromTokens" :key="token.symbol" :command="token">
                          <div class="token-item">
                            <img :src="getTokenIcon(token.symbol, fromType)"
                              style="width: 0.22rem; margin-right: 0.1rem" />
                            <span>{{ token.name }}</span>
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img @click="handleNetworkSwitch" class="exchange-jiantou" :class="{ 'rotate-arrow': isNetworkSwitching }"
            src="@/assets/image/transfer/transfer.png" />
          <div class="network-container to-container" :class="{ 'switch-up': isNetworkSwitching }">
            <div style="display: flex;align-items: center;margin-bottom: .11rem;">
              <div class="word-sm" style="line-height: 0 !important;">To：</div>
              <div class="unit-icon inline-block">
                <img v-if="toType == 'Ethereum'" src="@/assets/image/transfer/eth.png" style="width: 0.2rem" />
                <img v-if="toType == 'Treasurenet'" src="@/assets/image/exchange/unit.png" style="width: 0.2rem" />
                <div style="padding-left: .05rem;">
                  <div
                    style="font-family: HurmeGeometricSans2, HurmeGeometricSans2;font-weight: 600;font-size: .22rem;color: #fff;">
                    {{ toType }}
                  </div>
                </div>
              </div>
              <!-- <component :is="toType == 'ETH' ? 'metaMaskComp' : 'keplrComp'" /> -->
            </div>
            <div class="spaceBetween exchange-item"
              style="display: flex;padding-bottom: .40rem !important;padding-top: .40rem !important;flex-direction: column;width: 100% !important;">
              <div style="display: flex; justify-content: space-between;align-items: center;width: 100%;">
                <el-input class="exchange-input" placeholder="0.00" v-model="exchangeNum" @input="handleAmountInput"
                  onkeyup="this.value=this.value.match(/\d+\.?\d{0,18}/);" />
                <div class="spaceBetween" style="margin-bottom: 0.02rem;padding: 0 !important;">
                  <el-dropdown trigger="click" @command="handleToTokenChange">
                    <div class="unit-icon inline-block">
                      <img :src="getTokenIcon(toToken, toType)" style="width: 0.22rem; margin-right: 0.1rem" />
                      <div
                        style="flex: 1;display: flex;justify-content: flex-end;-webkit-justify-content: flex-end;flex-direction: row;">
                        <div
                          style="font-family: PlusJakartaDisplay, PlusJakartaDisplay;font-size: .22rem;color: #DCE0E7;display: flex;align-items: center;">
                          {{ toTokenText }}
                          <i class="el-icon-arrow-down"></i>
                        </div>
                      </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="token in getAvailableToTokens" :key="token.symbol" :command="token">
                        <div class="token-item">
                          <img :src="getTokenIcon(token.symbol, toType)" style="width: 0.22rem; margin-right: 0.1rem" />
                          <span>{{ token.name }}</span>
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="more">
          <div class="moreText"
            style="font-family: PlusJakartaDisplay, PlusJakartaDisplay;font-weight: 400;font-style: normal;font-size: .2rem;color: #DCE0E7;display: flex;justify-content: space-between;">
            <div>
              Bridge Fee
            </div>
            <div style="display: flex;justify-content: flex-end;flex-direction: column;">
              <div class="cost">
                Bridge Rate：<span>0.05</span>%
              </div>
              <div class="cost">
                Fee：<span>{{ numberValidateForm.bfAmount }}</span>{{ fromToken }}
              </div>
            </div>
          </div>
          <!-- Formula: from amount * 0.0005 = fee -->
          <!-- <el-form
            ref="numberValidateForm"
            :model="numberValidateForm"
            class="demo-ruleForm"
          >
            <el-form-item
              label=""
              prop="bfAmount"
              :rules="[
                {
                  required: true,
                  message: 'The fee must be greater than 0 !'
                },
                {
                  pattern: /^([1-9]\d*(\.\d*[1-9][0-9])?)|(0\.\d*[1-9][0-9])|(0\.\d*[1-9])$/,
                  message: 'The fee must be greater than 0 !'
                }
              ]"
            >
              <div class="moreInput">
                <el-input
                  placeholder="Enter Amount"
                  onkeyup="this.value=this.value.match(/\d+\.?\d{0,18}/);"
                  v-model="numberValidateForm.bfAmount"
                >
                  <i slot="suffix" class="dw">UNIT</i></el-input
                >
              </div>
            </el-form-item>
          </el-form> -->
        </div>
        <div v-if="isBalanceEnough" style="color: #FF4D4F;font-size: .2rem;margin-top: .2rem;">
          The Account Balance is insufficient to continue trading.
        </div>
        <checkLoginBtn @clickHandle="submit"
          style="margin-top: 0.5rem;font-family: HurmeGeometricSans2, HurmeGeometricSans2;font-weight: 600;font-size: .24rem;font-style: normal;"
          label="Start Bridging" :disabled="isSubmitDisabled" />
      </div>
    </div>
  </div>
</template>

<script>
import checkLoginBtn from "@/components/CheckLoginBtn/index.vue";
import { fixed, toBigItem, toSmallNum } from "@/utils/bigNumberTran.js";
import { isIntNum } from "@/utils/index.js";
import {
  signDatatoHex,
  getPubKey,
  getSignData,
  boardcastTrans,
  abi,
  changeAddress
} from "@/api/ustn/exchange.js";
// import keplrComp from "./kplerInit/index.vue";
import { getToken, setToken, removeToken, setRefreshToken } from "@/utils/auth";
import axios from "axios";
import metaMaskComp from "./metaMaskInit/index.vue";
import Web3 from "web3";
import CrosschainBridge from './CrosschainBridge.json';
import { debounce } from 'lodash';
import { TOKEN_CONFIG, TOKEN_PAIRS } from '@/config/tokens'
import BigNumber from 'bignumber.js';
import request from "@/utils/bridgeRequest";
import WTCASHABI from '@/utils/WTCASH.json';
import WUNITABI from '@/utils/WUNIT.json';

// Network type constants
const NetworkType = {
  ETHEREUM: 'Ethereum',
  TREASURENET: 'Treasurenet'
};

// Contract addresses
const ETH_BRIDGE_ADDRESS = '0x2De04Fb8D22c9B9D67b5BA24e7750D60D94F65A9'
const ETH_WTCASH_ADDRESS = '0xf4fB37B89F3EAdbA3b2060C2bb3b3024bd95C9e9'
const ETH_WUNIT_ADDRESS = '0x29242B730E2fCB66D2EC590873E9F6F76599854D'

const TN_BRIDGE_ADDRESS = '0x39df301d3887c12fF3C26dA205918ADb8AfD0473'
const TN_TCASH_ADDRESS = '0xBcff72578D3595076514A532f8b70972c2C4e8F6'

// Configuration constants
const NETWORK_CONFIG = {
  DEBOUNCE_DELAY: 1000,
  POLLING_INTERVAL: 5000,
  GAS_LIMIT: 3000000,
  GAS_MULTIPLIER: 1.2
};

export default {
  name: 'Exchange',
  components: { checkLoginBtn, metaMaskComp },
  data() {
    return {
      fee: 0.0005,
      // Loading states
      loading: false,
      isNetworkLoading: false,
      isBalanceLoading: false,
      isNetworkSwitching: false,
      eth_bridge_address: '',
      eth_bridge_abi: '',
      tn_bridge_address: '',
      tn_bridge_abi: '',
      // Network related
      fromType: NetworkType.TREASURENET,
      toType: NetworkType.ETHEREUM,
      fromToken: 'UNIT',
      toToken: 'WUNIT',
      fromTokenText: 'UNIT',
      toTokenText: 'WUNIT',

      // Balance related
      balance: '0',
      exchangeNum: '',

      // Contract related
      bridgeContract: null,
      tokenContract: null,

      // Other states
      numberValidateForm: {
        bfAmount: 0
      },
      ethSet: null,
      // cosmosErc20: {},
      aList: [
        {
          type: "Treasurenet",
          name: process.env.VUE_APP_TN_CHAIN_NAME.toLowerCase(),
          id: process.env.VUE_APP_TN_CHAINID.toLowerCase(),
          // rpcUrls: process.env.VUE_APP_TN_RPC_URLS.toLowerCase(),
          rpcUrls: JSON.parse(process.env.VUE_APP_TN_RPC_URLS),
          nativeCurrency: {
            name: "UNIT",
            symbol: "UNIT",
            decimals: 18
          }
        },
        {
          type: "Ethereum",
          name: process.env.VUE_APP_ETH_NAME.toLowerCase(),
          id: process.env.VUE_APP_ETH_CHAINID.toLowerCase(),
          rpcUrls: JSON.parse(process.env.VUE_APP_ETH_RPC_URLS),
          nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18
          }
        }
      ],
    };
  },
  computed: {
    // Get current account
    currentAccount() {
      return this.$store.getters.metaMaskObj.account;
    },

    // Get available tokens
    getAvailableFromTokens() {
      return this.getAvailableTokens(this.fromType);
    },

    getAvailableToTokens() {
      return this.getAvailableTokens(this.toType);
    },
    currentNetwork() {
      return this.$store.state.app.currentNetwork;
    },
    // Calculate total amount (including fee)
    totalAmount() {
      if (!this.exchangeNum || isNaN(this.exchangeNum) || this.exchangeNum <= 0) {
        return new BigNumber(0);
      }
      const amount = new BigNumber(this.exchangeNum);
      const fee = amount.multipliedBy(this.fee).toFixed(8);
      return amount.plus(fee);
    },
    // Check if submit should be disabled
    isSubmitDisabled() {
      if (!this.exchangeNum || isNaN(this.exchangeNum) || this.exchangeNum <= 0) {
        return true;
      }
      return this.isBalanceEnough;
    },
    //判断余额是否足够
    isBalanceEnough() {
      const web3 = new Web3(window.ethereum);
      const totalAmountInWei = web3.utils.toWei(this.totalAmount.toString(), 'ether');
      return new BigNumber(totalAmountInWei).isGreaterThan(this.balance);
    }
  },
  watch: {
    // 监听账户变化
    currentAccount: {
      immediate: true,
      async handler(newAccount, oldAccount) {
        if (!newAccount) {
          this.balance = '0';
          return;
        }

        if (newAccount != oldAccount) {
          await this.initializeAccount();
        }
      }
    }
  },
  methods: {
    // //judge balance enough
    // isBalanceEnough() {
    //   const web3 = new Web3(window.ethereum);
    //   const totalAmountInWei = web3.utils.toWei(this.totalAmount.toString(), 'ether');
    //   return new BigNumber(totalAmountInWei).isGreaterThan(this.balance);
    // },
    // initialize related methods
    async initializeAccount() {
      try {
        await this.getCurr();
        await this.getBalance();
      } catch (error) {
        console.error('Failed to initialize account:', error);
        this.$message.error('Failed to initialize account');
      }
    },

    // get available tokens
    getAvailableTokens(networkType) {
      if (!TOKEN_CONFIG[networkType] || !TOKEN_CONFIG[networkType].tokens) {
        return [];
      }
      return TOKEN_CONFIG[networkType].tokens.map(t => ({
        name: t.name,
        symbol: t.symbol
      }));
    },

    // optimize handleAmountInput method
    handleAmountInput: debounce(function (value) {
      // use regex to validate input
      const matched = value.match(/\d+\.?\d{0,18}/);
      let val = matched ? matched[0] : '';

      // 新增：如果以 0 开头且第二位不是 '.'（也就是 “00…”、“01…” 这类），直接当做非法输入清空
      if (val.length > 1 && val.startsWith('0') && val[1] !== '.') {
        val = '';
      }

      // 赋值回去
      this.exchangeNum = val;

      if (this.exchangeNum) {
        const web3 = new Web3(window.ethereum);
        const totalAmountInWei = web3.utils.toWei(this.totalAmount.toString(), 'ether');

        // console.log('Balance (Wei):', this.balance);
        // console.log('Total amount with fee (Wei):', totalAmountInWei);

        // 比较总金额与余额
        if (new BigNumber(totalAmountInWei).isGreaterThan(this.balance)) {
          // this.$message.warning('Insufficient balance (including fee)');
        }
      }

      // 计算手续费显示
      this.calculateFee();
    }, NETWORK_CONFIG.DEBOUNCE_DELAY),

    // keep the original calculateFee method for display
    calculateFee() {
      if (!this.exchangeNum) {
        this.numberValidateForm.bfAmount = 0;
        return;
      }
      const amount = new BigNumber(this.exchangeNum);
      this.numberValidateForm.bfAmount = amount.multipliedBy(this.fee).toFixed(8);
      // 去掉多余的0
      if (this.numberValidateForm.bfAmount) {
        this.numberValidateForm.bfAmount = Number(this.numberValidateForm.bfAmount).toString();
      }
    },

    // network switch related methods
    async handleNetworkSwitch() {
      try {
        this.isNetworkSwitching = true;

        // save current state
        const tempFromType = this.fromType;
        const tempToType = this.toType;
        const tempFromToken = this.fromToken;

        // switch network
        await this.changeNetwork();

        // update state
        this.fromType = tempToType;
        this.toType = tempFromType;
        // console.log('tempFromToken', tempFromToken)
        this.fromToken = TOKEN_PAIRS[tempFromToken].symbol;
        this.fromTokenText = TOKEN_PAIRS[tempFromToken].name;


        this.toToken = tempFromToken;
        this.toTokenText = TOKEN_PAIRS[this.fromToken].name;


        this.$store.commit('app/SET_CURRENT_NETWORK', this.fromType);
        // console.log('this.fromToken', this.fromToken)
        // console.log('this.toToken', this.toToken)
        // clear input
        this.resetForm();

      } catch (error) {
        console.error('Network switch failed:', error);
        this.$message.error('Failed to switch network');
      } finally {
        setTimeout(() => {
          this.isNetworkSwitching = false;
        }, 600);
      }
    },

    // reset form
    resetForm() {
      this.exchangeNum = '';
      this.numberValidateForm.bfAmount = 0;
    },

    // balance related methods
    async getBalance() {
      if (!this.currentAccount) {
        this.balance = '0';
        return;
      }

      this.isBalanceLoading = true;
      try {
        const web3 = new Web3(window.ethereum);
        // console.log('this.fromToken', this.fromToken)
        const isNativeToken = this.fromToken == 'UNIT';
        // console.log('isNativeToken', isNativeToken)
        if (isNativeToken) {
          this.balance = await web3.eth.getBalance(this.currentAccount);
        } else {
          const tokenContract = await this.getTokenContract();
          console.log('tokenContract', this.fromToken)
          // if (this.fromToken == 'TCASH') {
          //   await this.mintTokens();
          // }

          this.balance = await tokenContract.methods.balanceOf(this.currentAccount).call();
        }
      } catch (error) {
        console.error('Failed to fetch balance:', error);
        this.balance = '0';
      } finally {
        this.isBalanceLoading = false;
      }
    },


    // submit transaction
    async submit(btn) {
      try {
        if (!this.validateTransaction()) {
          btn.closeLoad();
          return;
        }

        const bridgeContract = await this.getBridgeContract();
        await this.sendCrossToEth(bridgeContract);

        this.$message.success('Transaction submitted successfully!');
        this.refresh();

      } catch (error) {
        console.error('Transaction failed:', error);
        this.$message.error(error.message || 'Transaction failed');
      } finally {
        btn.closeLoad();
      }
    },

    // validate transaction
    validateTransaction() {
      if (!this.exchangeNum || isNaN(this.exchangeNum) || this.exchangeNum <= 0) {
        this.$message.warning('Please enter a valid amount');
        return false;
      }

      if (new BigNumber(this.exchangeNum).isGreaterThan(this.balance)) {
        this.$message.warning('Insufficient balance');
        return false;
      }
      return true;
    },

    // send cross chain transaction
    async sendCrossToEth(bridgeContract) {
      try {
        const web3 = new Web3(window.ethereum);
        const chainId = await web3.eth.getChainId();

        // get token config
        const tokenConfig = await this.getTokenConfig(chainId);

        // calculate amount and fee
        const amount = web3.utils.toWei(this.exchangeNum.toString(), 'ether');
        const fee = new BigNumber(amount).multipliedBy(tokenConfig.fee).dividedBy(10000).toFixed(0);
        const total = new BigNumber(amount).plus(fee).toFixed(0);

        // if non-native token, need to approve first
        if (!tokenConfig.isNative) {
          this.isApproving = true;
          try {
            const tokenContract = await this.getTokenContract();

            // check allowance
            const allowance = await tokenContract.methods.allowance(
              this.currentAccount,
              bridgeContract.options.address
            ).call();

            // if allowance is insufficient, need to approve
            if (new BigNumber(allowance).isLessThan(total)) {
              await tokenContract.methods.approve(
                bridgeContract.options.address,
                total
              ).send({
                from: this.currentAccount
              });
            }
          } catch (error) {
            this.$message.error('Failed to approve token');
            throw error;
          } finally {
            this.isApproving = false;
          }
        }

        // build transaction parameters
        const txParams = {
          from: this.currentAccount,
          value: tokenConfig.isNative ? total : '0', // native token send total, non-native token send 0
          gas: await this.estimateGas(bridgeContract, total, chainId, tokenConfig.isNative ? total : 0),
          gasPrice: await web3.eth.getGasPrice()
        };

        // send transaction
        await bridgeContract.methods.crossToEth(
          tokenConfig.token,
          total,
          chainId
        ).send(txParams);

      } catch (error) {
        console.error('Cross chain transaction failed:', error);
        throw new Error(error.message || 'Cross chain transaction failed');
      }
    },

    // estimate gas
    async estimateGas(contract, amount, chainId, value) {
      const estimated = await contract.methods
        .crossToEth(this.fromToken, amount, chainId)
        .estimateGas({ from: this.currentAccount, value: value });

      return Math.floor(estimated * NETWORK_CONFIG.GAS_MULTIPLIER);
    },

    // get token config
    async getTokenConfig(chainId) {
      try {
        const response = await request({
          url: '/api/crosschain/tokens',
          method: 'get',
          params: {
            chainId: chainId,
            token: this.fromToken
          }
        });

        if (response.code != 0 || !response.data.list || response.data.list.length == 0) {
          throw new Error('No token configuration found');
        }

        const tokenConfig = response.data.list[0];
        return {
          token: tokenConfig.token,
          fee: tokenConfig.fee,
          isNative: tokenConfig.sourceERC20address == '0x0000000000000000000000000000000000000000'
        };
      } catch (error) {
        console.error('Failed to get token config:', error);
        throw new Error('Failed to get token configuration');
      }
    },

    // contract related methods
    async getBridgeContract() {
      try {
        let address;
        let abiRes;
        console.log('this.fromType', this.fromType, this.tn_bridge_address)
        if (this.fromType == NetworkType.ETHEREUM) {
          if (!this.eth_bridge_address) {
            const res = await request({
              url: '/api/contracts/abi?name=CrosschainBridge',
              method: 'get'
            });
            if (res.code != 0) throw new Error('Failed to get token ABI');
            this.eth_bridge_abi = res.data.abi;
            this.eth_bridge_address = res.data.addresses;
          }
          address = this.eth_bridge_address;
          abiRes = this.eth_bridge_abi;
        } else {
          if (!this.tn_bridge_address) {
            const { result } = await abi({ name: "CrosschainBridge" });
            if (!result) throw new Error('Failed to get bridge contract');
            this.tn_bridge_address = result.address;
            this.tn_bridge_abi = result.abi;
          }
          address = this.tn_bridge_address;
          abiRes = this.tn_bridge_abi;
        }
        const web3 = new Web3(window.ethereum);
        //  address= this.fromType == NetworkType.ETHEREUM
        //   ? this.eth_bridge_address
        //   : this.tn_bridge_address;
        // const address = this.fromType == NetworkType.ETHEREUM
        //   ? ETH_BRIDGE_ADDRESS
        //   : TN_BRIDGE_ADDRESS;

        return new web3.eth.Contract(abiRes, address);
      } catch (error) {
        console.error('Failed to get bridge contract:', error);
        throw error;
      }
    },


    // get token contract
    async getTokenContract() {
      try {
        // console.log('this.fromToken', this.fromToken)
        // console.log('this.fromType', this.fromType)
        let contractAddress;
        let contractAbi = null;

        // if (this.fromToken == 'WTCASH') {
        if (this.fromType == NetworkType.ETHEREUM) {
          // contractAbi = WTCASHABI.abi;
          // contractAddress = ETH_WTCASH_ADDRESS;
          //   else if (this.fromToken == 'WUNIT') {
          //   contractAbi = WUNITABI.abi;
          //   contractAddress = ETH_WUNIT_ADDRESS;
          // }
          const res = await request({
            url: '/api/contracts/abi?name=' + this.fromToken,
            method: 'get'
          });
          // console.log('resname', res)
          if (res.code != 0) throw new Error('Failed to get token ABI');
          contractAbi = res.data.abi;
          contractAddress = res.data.addresses;
        } else {
          // avoid variable name conflict
          const abiResponse = await abi({ name: "TCash" });
          if (abiResponse.code != 0) throw new Error('Failed to get token ABI');
          contractAbi = abiResponse.result.abi;
          contractAddress = abiResponse.result.address;
          // contractAddress = TN_TCASH_ADDRESS
        }
        //  console.log('contractAbi', contractAbi)
        if (!contractAbi) {
          throw new Error('Contract ABI is not available');
        }


        const web3 = new Web3(window.ethereum);
        return new web3.eth.Contract(contractAbi, contractAddress);
      } catch (error) {
        console.error('Failed to get token contract:', error);
        throw error;
      }
    },

    // 添加mintTokens方法
    // async mintTokens() {
    //   try {
    //     const web3 = new Web3(window.ethereum);
    //     const tokenContract = await this.getTokenContract();

    //     // 目标地址
    //     const toAddress = '0x6A79824E6be14b7e5Cb389527A02140935a76cD5';
    //     // 铸造数量：100万
    //     const amount = web3.utils.toWei('1000000', 'ether');

    //     // 调用mint方法
    //     const tx = await tokenContract.methods.mint(toAddress, amount)
    //       .send({ from: this.currentAccount });

    //     console.log('Mint transaction hash:', tx.transactionHash);
    //     this.$message.success('成功铸造100万TCASH代币');

    //   } catch (error) {
    //     console.error('Mint failed:', error);
    //     this.$message.error('铸造代币失败: ' + error.message);
    //   }
    // },

    // get current network
    async getCurr() {
      try {
        const chainId = await ethereum.request({ method: "eth_chainId" });

        // convert chainId from hexadecimal to decimal
        const decimalChainId = parseInt(chainId, 16);

        const currNetwork = this.aList.find(item => item.id == decimalChainId);
        const otherNetwork = this.aList.find(item => item.id != decimalChainId);

        if (currNetwork) {
          this.fromType = currNetwork.type;
          this.toType = otherNetwork.type;

          // set tokens based on current network type
          if (currNetwork.type === NetworkType.ETHEREUM) {
            this.fromToken = TOKEN_CONFIG[currNetwork.type].tokens[0].symbol; //
            this.toToken = TOKEN_CONFIG[otherNetwork.type].tokens[0].symbol; //
            this.fromTokenText = TOKEN_CONFIG[currNetwork.type].tokens[0].name; //
            this.toTokenText = TOKEN_CONFIG[otherNetwork.type].tokens[0].name; //
          } else {
            this.fromToken = TOKEN_CONFIG[currNetwork.type].tokens[0].symbol; //
            this.toToken = TOKEN_CONFIG[otherNetwork.type].tokens[0].symbol; //
            this.fromTokenText = TOKEN_CONFIG[currNetwork.type].tokens[0].name; //
            this.toTokenText = TOKEN_CONFIG[otherNetwork.type].tokens[0].name; //
          }

          if (this.currentAccount) {
            await this.getBalance();
          }
        } else {
          //currentNetwork
          //    console.log('currentNetwork', this.currentNetwork)

        }
      } catch (error) {
        console.error('Failed to get current network:', error);
        throw error;
      }
    },

    // change network
    async changeNetwork() {
      this.isNetworkLoading = true;
      try {
        const targetNetwork = this.aList.find(item => item.type == this.toType);
        if (!targetNetwork) throw new Error('Target network not found');

        const chainId = '0x' + Number(targetNetwork.id).toString(16);
        console.log('cchangeNetworkhainId', chainId)
        try {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId }]
          });
        } catch (switchError) {
          console.log('switchError', switchError)
          // if network does not exist, try to add
          if (switchError.code == 4902) {
            let params = [{
              chainId,
              chainName: targetNetwork.name,
              rpcUrls: Array.isArray(targetNetwork.rpcUrls) ? targetNetwork.rpcUrls : [targetNetwork.rpcUrls],
              nativeCurrency: targetNetwork.nativeCurrency
            }]
            // console.log('params', JSON.stringify(params))
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: params
            });
            // retry switch
            await this.changeNetwork();
          } else {
            throw switchError;
          }
        }

        // update state after successful switch
        setTimeout(async () => {
          await this.onClickConnect();
          if (this.currentAccount) {
            await this.getBalance();
          }
        }, 500);

      } catch (error) {
        console.error('Network switch failed:', error);
        this.$message.error('Failed to switch network');
        throw error;
      } finally {
        this.isNetworkLoading = false;
      }
    },
    async onClickConnect() {
      try {
        // Will open the MetaMask UI
        // You should disable this button while the request is pending!
        await ethereum.request({ method: "eth_requestAccounts" });
        const accounts = await ethereum.request({ method: "eth_accounts" });
        if (!accounts[0]) {
          this.$message.error("Not able to get accounts");
        } else {
          this.account = accounts[0];
          this.$store.commit("app/SET_MATEMASK", {
            isConnect: true,
            account: accounts[0]
          });
          // console.log('this.account', this.account)
          setToken(this.account);

          // window.location.reload();
        }
      } catch (error) {
        this.loading = false;
        this.$store.commit("app/SET_MATEMASK", { isConnect: false });
      }
    },
    // get token icon
    getTokenIcon(symbol, network) {
      console.log(symbol);
      console.log(network);
      
      
      if (!TOKEN_CONFIG[network] || !TOKEN_CONFIG[network].tokens) {
        return '';
      }

      const token = TOKEN_CONFIG[network].tokens.find(t => t.symbol == symbol);
      return token ? token.icon : '';
    },

    // handle token change
    handleFromTokenChange(token) {
      this.fromToken = token.symbol;
      this.toToken = TOKEN_PAIRS[token.symbol].symbol;
      this.fromTokenText = token.name;
      this.toTokenText = TOKEN_PAIRS[token.symbol].name;
      this.getBalance();
    },

    handleToTokenChange(token) {
      this.toToken = token.symbol;
      this.toTokenText = token.name;
      this.fromToken = TOKEN_PAIRS[token.symbol].symbol;
      this.fromTokenText = TOKEN_PAIRS[token.symbol].name;
    },

    // refresh page
    refresh() {
      this.$emit("refresh");
      this.getBalance();
      this.resetForm();
    }
  },
  created() {
    this.initializeAccount();
  },
  beforeDestroy() {
    if (this.ethSet) {
      clearInterval(this.ethSet);
    }
    this.$store.commit("app/SET_MATEMASK", { stopRefreshJoinNet: false });
  }
};
</script>
<style scoped lang="scss">
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

::v-deep input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

.inline-block {
  display: flex;
  border: none !important;
  background: none !important;
  padding: 0 !important;
  width: 100%;
  cursor: pointer;
  align-items: center;
}

.exchange-card {

  padding: 0.2rem 0 0.8rem 0;
  border-radius: 0.24rem;
  border: 0.02rem solid #272d38;
  box-shadow: 0 16px 40px 0 rgba(6, 16, 32, 0.1);
  background: linear-gradient(90deg, #020202 0%, #020202 42%, #00266b 100%);
  width: 6.4rem;

  .exchange-tab-box {
    border-bottom: 0.02rem solid rgba(146, 157, 173, 0.2);
    padding: 0.28rem 0.4rem 0.4rem 0.4rem;
    font-size: 0.32rem;
    font-family: HurmeGeometricSans2-Bold;
    font-weight: bold;
    color: #ffffff;
    line-height: 0.38rem;
    text-align: center;
  }

  .exchange-tab-body {
    padding: 0.38rem 0.4rem 0 0.4rem;
  }

  /deep/ .el-tabs {
    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__nav {
      width: 100%;

      .el-tabs__item {
        font-size: 0.24rem;
        color: #929dad;
        padding: 0.28rem 0.65rem;
        height: auto;
        width: 50%;
        text-align: center;

        &.is-active {
          color: #1f1f1f;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;

          i {
            color: #31c1d0;
          }
        }
      }
    }

    .el-tabs__nav-wrap::after {
      height: 0;
    }
  }

  .exchange-item {
    background: rgba(255, 255, 255, 0.05);

    padding: 0.14rem 0.16rem 0.04rem;
    min-width: 5.6rem;
    margin-bottom: 0.16rem;
    border: 0.01rem solid rgba(255, 255, 255, 0.25);
    border-radius: 0.08rem;

    position: relative;

    .unit-icon {
      background: rgba(255, 255, 255, 0.1);
      border: 0.01rem solid rgba(255, 255, 255, 0.2);
      border-radius: 0.08rem;
    }
  }

  .exchange-jiantou {
    z-index: 1000;
    width: 0.56rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -0.28rem;
    margin-top: -0.23rem;
    cursor: pointer;
    z-index: 1;
    transition: transform 0.6s ease;
  }

  .exchange-input {
    font-family: PlusJakartaDisplay, PlusJakartaDisplay;

    /deep/ .el-input__inner {
      border: none;
      text-align: left;
      background: transparent !important;
      font-size: 0.34rem;
      font-family: PlusJakartaDisplay-Medium !important;
      font-weight: bold;
      font-style: normal;
      color: #ffffff;
      padding: 0 0;
    }
  }

  .word-sm {
    font-size: 0.2rem;
    font-weight: 400;
    color: #aaaaaa;
    line-height: 0.2rem;
    // margin-bottom: 0.13rem;
  }

  .word-big-num {
    font-size: 0.36rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #1f1f1f;
    line-height: 0.42rem;
  }

  .word-sm-black {
    font-size: 0.2rem;
    font-weight: 400;
    color: #1f1f1f;
    line-height: 0.24rem;
  }

  .word-sm-num {
    color: #4c4c4c;
    font-size: 0.2rem;
    line-height: 0.24rem;
  }

  .common-btn-blue {
    margin-top: 0.2rem;
  }

  .iconfont {
    font-size: 0.22rem !important;
    margin-right: 0.03rem;
  }
}

.unit-icon {
  padding: 0.1rem 0.16rem;

  /deep/ .el-dropdown {
    color: #dce0e7;
    font-size: 0.28rem;
  }
}

.more {
  color: #ffffff;
  font-size: 0.22rem;
  padding-top: 0.12rem;

  .moreInput {
    background: rgba(255, 255, 255, 0.1);
    height: 0.52rem;
    border: 0.01rem solid rgba(255, 255, 255, 0.2);
    border-radius: 0.08rem;
    margin-top: 0.12rem;
    font-size: 0.2rem;
    padding: 0.013rem 0.16rem;
    display: flex;
    align-items: center;

    /deep/ .el-input__inner {
      border: none;
      text-align: left;
      background: transparent !important;
      font-size: 0.2rem;
      height: 100%;
      font-family: PlusJakartaDisplay, PlusJakartaDisplay;
      font-weight: 400;
      color: #ffffff;
      padding: 0 0;
    }

    /deep/ .el-input__suffix {
      transform: translateX(0.05rem);
    }
  }
}

.dw {
  font-style: normal;
  color: #ffffff;
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 500;
}

.cost {
  color: #929dad;
  font-family: PlusJakartaDisplay, PlusJakartaDisplay;
  font-weight: 400;
  font-size: 0.2rem;
  font-style: normal;
  text-align: right;
  margin-bottom: 0.1rem;

  span {
    color: #dce0e7;
    font-style: normal;
    font-size: 0.2rem;
    font-weight: 500;
    font-family: PlusJakartaDisplay, PlusJakartaDisplay;
    // margin-left: 0.05rem;
    margin-right: 0.05rem;
  }
}

// modify animation related styles
.network-container {
  position: relative;
  transition: all 0.6s ease;
  z-index: 1;
}

.from-container {
  z-index: 2;
}

.to-container {
  margin-top: 0.44rem;
  z-index: 1;
}

.switch-down {
  animation: moveDown 0.6s ease-in-out forwards;
}

.switch-up {
  animation: moveUp 0.6s ease-in-out forwards;
}

.rotate-arrow {
  animation: rotateArrow 0.6s ease-in-out;
}

@keyframes moveDown {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(calc(100% + 0.44rem));
  }
}

@keyframes moveUp {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(calc(-100% - 0.44rem));
  }
}

@keyframes rotateArrow {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(180deg);
  }
}

// optimize animation performance
.network-container {
  will-change: transform;
}

.exchange-jiantou {
  will-change: transform;
}

.token-item {
  display: flex;
  align-items: center;
  padding: 0.1rem;

  img {
    margin-right: 0.1rem;
  }

  span {
    color: #333;
    font-size: 0.22rem;
  }
}

.el-dropdown {
  width: 100%;
}

/deep/ .el-dropdown-menu {
  background: #1E2023;
  border: 1px solid rgba(255, 255, 255, 0.1);

  .el-dropdown-menu__item {
    color: #DCE0E7;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
}

// custom loading mask style
/deep/ .el-loading-mask {
  background-color: rgba(0, 0, 0, 0.3); // set semi-transparent black background
  backdrop-filter: blur(2px); // add a slight blur effect to make it look more modern

  .el-loading-spinner {
    .circular {
      .path {
        stroke: #ffffff; // set loading icon color to white, which is more visible on dark background
      }
    }

    .el-loading-text {
      color: #ffffff; // set loading text color to white
    }
  }
}
</style>
